<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocReassuranceAvisX9'
});
</script>
<template>
  <ka-container
    code="bloc-reassurance-avis-x-9"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container -->
    <ka-container code="container">
      <!-- Colonne -->
      <ka-container code="colonne">
        <!-- Témoignage x -->
        <ka-container code="temoignage-x">
          <ka-image
            code="image"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture01.value" />
          <ka-text code="temoin">
            <span v-html="componentInstance.$customer01.value" />
          </ka-text>
          <ka-text
            code="texte-2"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.colonne.temoignageX.texte2.value', `{0} `, [componentInstance.$testimonial01.value])" />
          </ka-text>
        </ka-container>
        <!-- Témoignage x -->
        <ka-container code="container-1">
          <ka-image
            code="image-1"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture02.value" />
          <ka-text code="text-1">
            <span v-html="componentInstance.$customer02.value" />
          </ka-text>
          <ka-text
            code="text-2"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.colonne.container1.text2.value', `{0} `, [componentInstance.$testimony02.value])" />
          </ka-text>
        </ka-container>
        <!-- Témoignage x -->
        <ka-container code="container-2">
          <ka-image
            code="image-2"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture06.value" />
          <ka-text code="text-3">
            <span v-html="componentInstance.$customer06.value" />
          </ka-text>
          <ka-text
            code="text-4"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.colonne.container2.text4.value', `{0} `, [componentInstance.$testimony06.value])" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Colonne -->
      <ka-container code="container-3">
        <!-- Témoignage x -->
        <ka-container code="container-4">
          <ka-image
            code="image-3"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture05.value" />
          <ka-text code="text-5">
            <span v-html="componentInstance.$customer05.value" />
          </ka-text>
          <ka-text
            code="text-6"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.container3.container4.text6.value', `{0} `, [componentInstance.$testimony05.value])" />
          </ka-text>
        </ka-container>
        <!-- Témoignage x -->
        <ka-container code="container-5">
          <ka-image
            code="image-4"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture04.value" />
          <ka-text code="text-7">
            <span v-html="componentInstance.$customer04.value" />
          </ka-text>
          <ka-text
            code="text-8"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.container3.container5.text8.value', `{0} `, [componentInstance.$testimony04.value])" />
          </ka-text>
        </ka-container>
        <!-- Témoignage x -->
        <ka-container
          code="container-6"
          :xs="{ hidden: null }">
          <ka-image
            code="image-5"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture03.value" />
          <ka-text code="text-9">
            <span v-html="componentInstance.$customer03.value" />
          </ka-text>
          <ka-text
            code="text-10"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.container3.container6.text10.value', `{0} `, [componentInstance.$testimonial03.value])" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Colonne -->
      <ka-container code="container-7">
        <!-- Témoignage x -->
        <ka-container code="container-8">
          <ka-image
            code="image-6"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture07.value" />
          <ka-text code="text-11">
            <span v-html="componentInstance.$customer07.value" />
          </ka-text>
          <ka-text
            code="text-12"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.container7.container8.text12.value', `{0} `, [componentInstance.$testimony07.value])" />
          </ka-text>
        </ka-container>
        <!-- Témoignage x -->
        <ka-container
          code="container-9"
          :xs="{ hidden: null }">
          <ka-image
            code="image-7"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`
            }"
            :value="componentInstance.$picture08.value" />
          <ka-text code="text-13">
            <span v-html="componentInstance.$customer08.value" />
          </ka-text>
          <ka-text
            code="text-14"
            inner>
            <span v-html="t('blocReassuranceAvisX9.container.container7.container9.text14.value', `{0} `, [componentInstance.$testimony08.value])" />
          </ka-text>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocReassuranceAvisX9Component } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c50')
const component = blocReassuranceAvisX9Component()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  picture01?: Nullable<string | File>
  customer01?: Nullable<string>
  testimonial01?: Nullable<string>
  picture02?: Nullable<string | File>
  customer02?: Nullable<string>
  testimony02?: Nullable<string>
  picture03?: Nullable<string | File>
  customer03?: Nullable<string>
  testimonial03?: Nullable<string>
  picture04?: Nullable<string | File>
  customer04?: Nullable<string>
  testimony04?: Nullable<string>
  picture05?: Nullable<string | File>
  customer05?: Nullable<string>
  testimony05?: Nullable<string>
  picture06?: Nullable<string | File>
  customer06?: Nullable<string>
  testimony06?: Nullable<string>
  picture07?: Nullable<string | File>
  customer07?: Nullable<string>
  testimony07?: Nullable<string>
  picture08?: Nullable<string | File>
  testimony08?: Nullable<string>
  customer08?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  picture01: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer01: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimonial01: 'Ce que j’ai aimé avec Matchers c’est que ce sont des gens dans la pratique qui vont nous aider à le mettre en œuvre. <strong>Les experts savent de quoi ils parlent</strong> et on est tout de suite dans quelque chose d\'extrêmement <strong>utile et concret</strong>.',
  picture02: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer02: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimony02: 'D’après moi, ce n’est qu’en faisant qu’on apprend et lors de cette formation Matchers, nous avons réellement appris. Dès la fin de la formation, nous avons tout de suite décidé de repartir sur une nouvelle demande de financement pour une nouvelle formation Matchers.',
  picture03: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer03: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimonial03: 'Excellent intermédiaire avec les OPCOs qui sont parfois des dédales administratifs qui rebutent à tout initiative de formation. Avec Stéphane (de Matchers) tout est beaucoup plus clair et j\'ai pu mettre en place une formation en marketing digital pour améliorer notre acquisition en ligne, la formation s\'est très bien passée la formatrice top. Je recommande vivement.',
  picture04: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer04: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimony04: 'Excellent intermédiaire avec les OPCOs qui sont parfois des dédales administratifs qui rebutent à tout initiative de formation. Avec Stéphane (de Matchers) tout est beaucoup plus clair et j\'ai pu mettre en place une formation en marketing digital pour améliorer notre acquisition en ligne, la formation s\'est très bien passée la formatrice top. Je recommande vivement.',
  picture05: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer05: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimony05: 'Excellent intermédiaire avec les OPCOs qui sont parfois des dédales administratifs qui rebutent à tout initiative de formation. Avec Stéphane (de Matchers) tout est beaucoup plus clair et j\'ai pu mettre en place une formation en marketing digital pour améliorer notre acquisition en ligne, la formation s\'est très bien passée la formatrice top. Je recommande vivement.',
  picture06: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer06: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimony06: 'Excellent intermédiaire avec les OPCOs qui sont parfois des dédales administratifs qui rebutent à tout initiative de formation. Avec Stéphane (de Matchers) tout est beaucoup plus clair et j\'ai pu mettre en place une formation en marketing digital pour améliorer notre acquisition en ligne, la formation s\'est très bien passée la formatrice top. Je recommande vivement.',
  picture07: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  customer07: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  testimony07: 'Excellent intermédiaire avec les OPCOs qui sont parfois des dédales administratifs qui rebutent à tout initiative de formation. Avec Stéphane (de Matchers) tout est beaucoup plus clair et j\'ai pu mettre en place une formation en marketing digital pour améliorer notre acquisition en ligne, la formation s\'est très bien passée la formatrice top. Je recommande vivement.',
  picture08: 'https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/',
  testimony08: 'Excellent intermédiaire avec les OPCOs qui sont parfois des dédales administratifs qui rebutent à tout initiative de formation. Avec Stéphane (de Matchers) tout est beaucoup plus clair et j\'ai pu mettre en place une formation en marketing digital pour améliorer notre acquisition en ligne, la formation s\'est très bien passée la formatrice top. Je recommande vivement.',
  customer08: `Lili | Co-gérante du Domaine d'Arton
Formation en développement commercial`,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:picture01',
  'update:customer01',
  'update:testimonial01',
  'update:picture02',
  'update:customer02',
  'update:testimony02',
  'update:picture03',
  'update:customer03',
  'update:testimonial03',
  'update:picture04',
  'update:customer04',
  'update:testimony04',
  'update:picture05',
  'update:customer05',
  'update:testimony05',
  'update:picture06',
  'update:customer06',
  'update:testimony06',
  'update:picture07',
  'update:customer07',
  'update:testimony07',
  'update:picture08',
  'update:testimony08',
  'update:customer08'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    picture01: true,
    customer01: true,
    testimonial01: true,
    picture02: true,
    customer02: true,
    testimony02: true,
    picture03: true,
    customer03: true,
    testimonial03: true,
    picture04: true,
    customer04: true,
    testimony04: true,
    picture05: true,
    customer05: true,
    testimony05: true,
    picture06: true,
    customer06: true,
    testimony06: true,
    picture07: true,
    customer07: true,
    testimony07: true,
    picture08: true,
    testimony08: true,
    customer08: true
  }
})
</script>
